import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function BackButton() {
  const { t } = useTranslation();

  return (
    <button
      className="nav-back"
      onClick={() => {
        window.history.back();
      }}
      style={{
        position: "absolute",
        top: "100px",
        left: "20px",
        color: "#333",
      }}
    >
      <ArrowLeft size={16} />
      {t("common.back")}
    </button>
  );
}
